import { AppOfTheDayIcon, AppRatingIcon } from 'fitify-ui/src/Icon/custom'

import {
  type StyledRatingHeaderProps,
  StyledRatingHeader,
} from './HeaderRating.Styled'

export const HeaderRating = ({ variant }: StyledRatingHeaderProps) => {
  return (
    <StyledRatingHeader variant={variant}>
      <AppOfTheDayIcon aria-label="Fitify.com - App of the Day" />
      <AppRatingIcon aria-label="Fitify.com - Rating" />
    </StyledRatingHeader>
  )
}
